import { ReactNode } from 'react';

import { Box, Divider, SxProps, Theme, Typography } from '@mui/material';

type SectionHeaderProps = Readonly<{
  title: string;
  supporting?: string;
  /** Right-aligned action (e.g. a Lubav button). */
  action?: ReactNode;
}>;

/** Section title with an optional supporting line and right-aligned action, over a full-width divider. */
export const SectionHeader = ({ title, supporting, action }: SectionHeaderProps) => (
  <Box sx={rootSx}>
    <Box sx={rowSx}>
      <Box sx={textSx}>
        <Typography variant="display-xs-semibold" sx={titleSx}>
          {title}
        </Typography>
        {supporting && (
          <Typography variant="text-sm-regular" sx={supportingSx}>
            {supporting}
          </Typography>
        )}
      </Box>
      {action ? <Box sx={actionSx}>{action}</Box> : null}
    </Box>
    <Divider sx={dividerSx} />
  </Box>
);

const rootSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-lg'],
});

const rowSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: backrs.spacing['spacing-xl'],
  flexWrap: 'wrap',
});

const textSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-xxs'],
  minWidth: 0,
});

const titleSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-primary'],
});

const supportingSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-tertiary'],
});

const actionSx: SxProps<Theme> = {
  flexShrink: 0,
};

const dividerSx: SxProps<Theme> = ({ backrs }) => ({
  borderColor: backrs.colors['Beige/950'],
});
